module Eseebase {

    export class FloorplanChangelogItem {
        createdOn: string;
        createdBy: string;
        sheetNumber: string;
        statuses: FloorplanChangelogStatusItem[];
        expanded: boolean;
        priority: string;
    }

    export class FloorplanChangelog {
        fileDetails: FileDetailsViewModel;
        items: FloorplanChangelogStatusItem[];
    }

    export class FloorplanChangelogStatusItem {
        createdOn: string;
        createdBy: string;
        status: string;
        id: string;
        isClosed: boolean;
        priority: string;
    }

    export class FloorplanViewModel {
        urls: FloorplanUrlViewModel[];
        companyNumber: string;
        customerName: string;
        address: string;
        associationNumber: string;
        departmentNumber: string;
        apartmentId: string;
        localizer: string;
        housingNumber: string;
        hasCorrection: boolean;
        canEditCorrection: boolean;
        isModified: boolean;
        has2D: boolean;
        isExpanded: boolean;
        changelog: FloorplanChangelog;
    }

    export class FloorplanUrlViewModel {
        id: string;
        url: string;
        alternativeUrl: string;
        fileName: string;
        is3D: boolean;
        isPdf: boolean;
    }

    export class FloorPlanPagedResult {
        pageNumber: number;
        totalNumberOfPages: number;
        totalNumberOfRecords: number;
        results: FloorplanViewModel[];
        isLastPage: boolean;
        lastId: string;
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
        }
    }
}